import { isValidEmail } from '@domain-group/javascript-utils'

export type Deadlines = {
  [key: string]: {
    time: string,
  },
}

export type ProviderModel = {
  accounts_email?: string,
  accounts_phone?: string,
  active: boolean,
  address_line_1: string,
  address_line_2?: string,
  address_postcode: string,
  address_region: string,
  address_state: string,
  alternate_logo?: {
    file_name?: string | null,
    original: string | null,
    thumb: string | null,
  },
  bank_account_bsb?: string,
  bank_account_name?: string,
  bank_account_number?: string,
  billing_start_date?: string,
  business_number: string,
  cache_key: number,
  data?: {
    external_ids?: {
      realbase?: number,
    },
  },
  deadlines?: Deadlines,
  details_colour?: string,
  email: string,
  font_colour?: string,
  font_light_colour?: string,
  geo_country_id: undefined,
  highlight_colour?: string,
  id: number,
  image_mode?: string,
  in_house?: boolean,
  is_publication_provider?: boolean,
  invoice_pdf_file?: string,
  invoice_pdf_file_name?: string,
  last_billed_at?: string,
  logo?: {
    file_name: string,
    thumb: string,
  },
  order_api?: string,
  notes_enabled?: boolean,
  options?: {
    closed_days?: string[],
    downsample_color_images?: boolean,
    image_icc_profile?: string,
    image_icc_profile_rgb?: string,
    image_quality?: string,
    job_ticket_layout?: string,
    optimize_files?: boolean,
    order_api_endpoint?: string,
    order_total_override?: boolean,
    outline_pdf_fonts?: boolean,
    pdf_compatibility?: string,
    pricing_api?: string,
    require_identity_code?: boolean,
    slack_booking_updates_webhook_url?: string,
    slack_project_comments_webhook_url?: string,
    slack_task_updates_webhook_url?: string,
    strip_image_profile?: string,
  },
  phone: string,
  realhub_platform?: string,
  salesforce_id?: string,
  salesforce_details?: {
    accounts_email: string,
    accounts_phone: string,
    active: boolean,
    address_country: string,
    address_line_1: string,
    address_postcode: string,
    address_region: string,
    address_state: string,
    business_number: string,
    geo_country_id: number,
    phone: string,
    title: string,
    website: string,
  },
  service_ids?: number[],
  service_product_ids?: number[],
  service_types?: string[],
  short_name?: string,
  title: string,
  type: string,
  webhooks?: string[],
  website: string,
  zuora_account_number?: string,
}

export type ProviderRequestOptions = {
  include_provider_alternate_logo?: boolean,
  include_provider_blockout_dates?: boolean,
  include_provider_disclaimers?: boolean,
  include_provider_logo?: boolean,
  include_provider_service_types?: boolean,
}

const state = {
  accounts_email: '',
  accounts_phone: '',
  active: true,
  address_line_1: '',
  address_line_2: '',
  address_postcode: '',
  address_region: '',
  address_state: '',
  bank_account_bsb: '',
  bank_account_name: '',
  bank_account_number: '',
  billing_start_date: '',
  business_number: '',
  data: {},
  details_colour: '',
  email: '',
  font_colour: '',
  font_light_colour: '',
  geo_country_id: undefined,
  highlight_colour: '',
  id: null,
  image_mode: '',
  in_house: false,
  invoice_pdf_file: null,
  invoice_pdf_file_name: '',
  last_billed_at: '',
  order_api: '',
  notes_enabled: false,
  options: {
    closed_days: [],
    downsample_color_images: false,
    image_icc_profile: '',
    image_icc_profile_rgb: '',
    image_quality: '',
    job_ticket_layout: 'orders',
    optimize_files: false,
    order_api_endpoint: '',
    order_total_override: false,
    outline_pdf_fonts: false,
    pdf_compatibility: '',
    pricing_api: '',
    require_identity_code: false,
    slack_booking_updates_webhook_url: '',
    slack_project_comments_webhook_url: '',
    slack_task_updates_webhook_url: '',
    strip_image_profile: 'false',
  },
  phone: '',
  salesforce_id: '',
  short_name: '',
  title: '',
  webhooks: [],
  website: '',
  zuora_account_number: '',
}

export const requiredFields = [
  { key: 'address_line_1' },
  { key: 'address_postcode' },
  { key: 'address_region' },
  { key: 'address_state' },
  { key: 'business_number' },
  {
    key: 'email',
    validation: (value: string) => {
      const emails = value.split(',').map(email => email.trim()).filter(string => string)
      return emails.every(email => isValidEmail(email))
    },
    invalidMessage: 'Invalid Email format',
  },
  { key: 'geo_country_id' },
  { key: 'phone' },
  { key: 'title' },
  { key: 'website' },
]

export default state
